import { SectionHeader, Eyebrow, ToolCard, FadeIn } from "./primitives";
import { toolsDaily, toolsExplore, toolsFellowship } from "@/data/dashboard";
import { toast } from "@/components/ui/sonner";

export const ToolsSection = () => {
  const open = (title) =>
    toast(`Opening ${title}`, { description: "This is a design prototype." });

  return (
    <FadeIn>
      <section>
        <SectionHeader
          title="Tools"
          caption="Use what helps. Hide what doesn't."
        />

        <Eyebrow className="block">Daily Practice</Eyebrow>
        <div className="mt-3 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
          {toolsDaily.map((t) => (
            <ToolCard
              key={t.id}
              icon={t.icon}
              title={t.title}
              desc={t.desc}
              onClick={() => open(t.title)}
              testId={`tool-${t.id}`}
            />
          ))}
        </div>

        <Eyebrow className="mt-9 block">Explore</Eyebrow>
        <div className="mt-3 grid grid-cols-2 gap-3 sm:grid-cols-4">
          {toolsExplore.map((t) => (
            <ToolCard
              key={t.id}
              icon={t.icon}
              title={t.title}
              compact
              onClick={() => open(t.title)}
              testId={`tool-${t.id}`}
            />
          ))}
        </div>

        <div className="mt-9 flex flex-wrap items-center justify-between gap-x-6 gap-y-1">
          <Eyebrow>Fellowship Tools</Eyebrow>
          <p className="text-[13px] text-muted-foreground">
            Only visible to you, only because you opted in.
          </p>
        </div>
        <div className="mt-3 grid grid-cols-1 gap-3 sm:grid-cols-3">
          {toolsFellowship.map((t) => (
            <ToolCard
              key={t.id}
              icon={t.icon}
              title={t.title}
              tag={t.tag}
              onClick={() => open(t.title)}
              testId={`tool-${t.id}`}
            />
          ))}
        </div>
      </section>
    </FadeIn>
  );
};
